document.addEventListener('DOMContentLoaded', () => { 
    console.log("Wishlist initialized")
    const unique = (array, propertyName) => {
        return array.filter((e, i) => array.findIndex(a => a[propertyName] === e[propertyName]) === i);
    }
    
    const createMetafield = (value, local, isRemove) => {
        const stored = window.UBBFavorites;
        let localBuild = [];
        let storeBuild = [];
        if(local.length) {
            localBuild = local;
        }
        if(stored.length) {
            storeBuild = stored;
        }
        const builtArr = [...localBuild, ...storeBuild, value];
        const filteredArr = isRemove ? builtArr.filter((item) => item.id != value.id) : builtArr;
  
        const uniqueValues = unique(filteredArr, "id");
        localStorage.setItem("ubb-favorites", JSON.stringify(uniqueValues));
        window.UBBFavorites = uniqueValues;
        return fetch(`/a/ubb/metafields/create?customerId=${window.customerId}`, {
                method: 'POST',
                headers: {
                    'X-Shopify-Access-Token': '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',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'metafield': {
                        'namespace': 'meta',
                        'key': "favorites",
                        'value': `${JSON.stringify([...uniqueValues])}`,
                        'type': "json"
                    }
                })
              });
    };

    const saveFavoriteLocally = (value, state) => {
        const favorites = getFavoritesLocalValue();
        if(favorites.length) {
          localStorage.setItem("ubb-favorites", JSON.stringify(state ? favorites.filter((item) => item.id != value.id) : [...favorites, value]))
        } else {
          localStorage.setItem("ubb-favorites", JSON.stringify(state ? [] : [value]))
        }
      }

    const getFavoritesLocalValue = () => {
        const favorites_data = localStorage.getItem("ubb-favorites");
        const favorites = !!favorites_data ? JSON.parse(favorites_data) : [];
        return favorites
    }
    const buildFavoritesLocally = () => {
        const favorites = getFavoritesLocalValue();
        $(".temporary").html("");
        favorites.forEach(favorite => {
            const stringTemplate = `
            <li class="favorite-card list-item">
            <div class="item-view">
                <button class="delete-item" aria-label="remove item">
                    <div class="delete-item-container">
                        <div class="close-small item-button" data-local="true" data-auto="delete-item" data-close="${favorite.id}">
                            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 15 15"><path fill="#231f20" d="M8.48 7.5l6.31-6.31A.69.69 0 0 0 15 .7a.68.68 0 0 0-.21-.49.69.69 0 0 0-1 0L7.5 6.52 1.19.2A.69.69 0 0 0 .7 0a.68.68 0 0 0-.5.21.7.7 0 0 0 0 1L6.52 7.5.2 13.81a.7.7 0 0 0-.2.49.69.69 0 0 0 .2.49.7.7 0 0 0 .5.21.69.69 0 0 0 .49-.21L7.5 8.48l6.31 6.31a.7.7 0 0 0 .49.2.68.68 0 0 0 .49-.2.7.7 0 0 0 0-1z"/></svg>
                        </div>
                    </div>
                </button>
            <div class="img-container">
                <img class="f-image" src="${favorite.image}"/>
    
            </div>
            <div class="item-details">
                <div class="t card__heading h5">${favorite.name}</div>
                <div class="t caption-with-letter-spacing light">Color: ${favorite.color}</div>
                <div class="t caption-with-letter-spacing light">Size: ${favorite.size}</div>
                <div class="t price-item price-item--sale price-item--last">${favorite.price}</div>
                <div class="button-container">
                    <form method="post" action="/cart/add" id="product-form-${favorite.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${favorite.id}">
                    <div class="product-form__buttons active">
                        <button type="submit" name="add" class="add-to-cart btn--is-full-width invert is-rounded button--primary">
                            <span>
                              Add to cart
                            </span>
                            <div class="loading-overlay__spinner hidden">
                              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                        </button>
                    </div>
                </form></div>
            </div>
            
    </div>
        </li>
            `;
    
            $(".temporary").append(stringTemplate);
        });
    }
    

    const buildFavoritesRemote = () => {
        const favorites = !!window.UBBFavorites ? window.UBBFavorites : [] ;
        $(".active.gridLayout").html("");
        favorites.forEach(favorite => {
            const stringTemplate = `
            <li class="favorite-card list-item">
            <div class="item-view">
                <button class="delete-item" aria-label="remove item">
                    <div class="delete-item-container">
                        <div class="close-small item-button" data-local="false" data-auto="delete-item" data-close="${favorite.id}">
                            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 15 15"><path fill="#231f20" d="M8.48 7.5l6.31-6.31A.69.69 0 0 0 15 .7a.68.68 0 0 0-.21-.49.69.69 0 0 0-1 0L7.5 6.52 1.19.2A.69.69 0 0 0 .7 0a.68.68 0 0 0-.5.21.7.7 0 0 0 0 1L6.52 7.5.2 13.81a.7.7 0 0 0-.2.49.69.69 0 0 0 .2.49.7.7 0 0 0 .5.21.69.69 0 0 0 .49-.21L7.5 8.48l6.31 6.31a.7.7 0 0 0 .49.2.68.68 0 0 0 .49-.2.7.7 0 0 0 0-1z"/></svg>
                        </div>
                    </div>
                </button>
            <div class="img-container">
                <img class="f-image" src="${favorite.image}"/>
    
            </div>
            <div class="item-details">
                <div class="t card__heading h5">${favorite.name}</div>
                <div class="t caption-with-letter-spacing light">Color: ${favorite.color}</div>
                <div class="t caption-with-letter-spacing light">Size: ${favorite.size}</div>
                <div class="t price-item price-item--sale price-item--last">${favorite.price}</div>
                <div class="button-container">
                    <form method="post" action="/cart/add" id="product-form-${favorite.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${favorite.id}">
                    <div class="product-form__buttons active">
                        <button type="submit" name="add" class="add-to-cart btn--is-full-width invert is-rounded button--primary">
                            <span>
                              Add to cart
                            </span>
                            <div class="loading-overlay__spinner hidden">
                              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                        </button>
                    </div>
                </form></div>
            </div>
            
    </div>
        </li>
            `;
    
            $(".active.gridLayout").append(stringTemplate);
        });
    }

    buildFavoritesLocally();
    buildFavoritesRemote();
    $(".close-small").on("click", (e) => {
        console.log($(e.currentTarget).data())
        const varId = $(e.currentTarget).data().close;
        if(!!$(e.currentTarget).data().local) {
            saveFavoriteLocally({id: varId}, true);
            buildFavoritesLocally()
        } else {
            createMetafield({id: varId}, getFavoritesLocalValue(), true).then((data) => {
                console.log("data: ", data)
                buildFavoritesRemote();
            });
        }

    })
});